import { useApiQuery } from './useApiQuery';
import { useApiMutation } from './useApiMutation';
import { settingsService } from '../services/settingsService';
import { queryTags } from '../queryTags';
import { getQueryClient } from '../queryClient';
import type { UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import type {
  GetSettingsParams,
  CreateSettingPayload,
  UpdateSettingPayload,
} from '../types/settings.types';

export function useGetSettings(
  params?: GetSettingsParams,
  options?: Omit<UseQueryOptions<any, any, any, any[]>, 'queryKey' | 'queryFn'>
) {
  return useApiQuery({
    queryKey: [
      queryTags.settings,
      params?.type,
      params?.page || 1,
      params?.limit || 10,
      params?.search || '',
    ],
    queryFn: () => settingsService.getSettings(params),
    ...options,
  });
}

export function useCreateSetting(
  options?: UseMutationOptions<any, any, CreateSettingPayload, any>
) {
  return useApiMutation<any, any, CreateSettingPayload, any>({
    mutationFn: ((data: CreateSettingPayload) => settingsService.createSetting(data)) as any,
    onSuccess: () => {
      getQueryClient().invalidateQueries({ queryKey: [queryTags.settings] });
    },
    ...options,
  });
}

export function useUpdateSetting(
  options?: UseMutationOptions<any, any, { id: string; data: UpdateSettingPayload }, any>
) {
  return useApiMutation<any, any, { id: string; data: UpdateSettingPayload }, any>({
    mutationFn: ((variables: { id: string; data: UpdateSettingPayload }) =>
      settingsService.updateSetting(variables.id, variables.data)) as any,
    onSuccess: () => {
      getQueryClient().invalidateQueries({ queryKey: [queryTags.settings] });
    },
    ...options,
  });
}

export function useDeleteSetting(
  options?: UseMutationOptions<any, any, string, any>
) {
  return useApiMutation<any, any, string, any>({
    mutationFn: ((id: string) => settingsService.deleteSetting(id)) as any,
    onSuccess: () => {
      getQueryClient().invalidateQueries({ queryKey: [queryTags.settings] });
    },
    ...options,
  });
}


